import { useState } from "react";
import { Box, Dialog, DialogContent, Grid, Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useDispatch } from "react-redux";
import { LAYOUT_MARGIN } from "Configs/home";
import MyGrafanaChart from "./Grafana";

import SubReport from "./subReports";
import { REPORT_DATA } from "./reportData";
import SingleReport from "./singleReport";

export default function Reports() {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [selectedReport, setSelectedReport] = useState(1);

  const handleClickOpen = (value: number) => {
    console.log(value, "bfbfbcc");
    setSelectedReport(value);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const pStyle: any = {
    fontSize: "24px",
    height: "35%",
    width: "100%",
    textAlign: "center",
  };

  const bStyle = {
    width: "100%",
    border: "1px solid #b7b6b6c4",
    borderRadius: "0 60px",
    height: "27vh",
    "&:hover": { transform: "scale(1.05)" },
    transition: "all 0.3s ease-in-out",
    cursor: "pointer",
    alignItems: "center",
  };

  const imgStyle = {
    width: "25%",
    height: "65%",
    display: "block",
    margin: "auto",
    opacity: "0.5",
  };

  return (
    <>
      <Box sx={{ flexGrow: 1, direction: "rtl" }}>
        {/* <Grid container spacing={5} p={4} sx={{ direction: "ltr", marginTop: "20px", justifyContent: "center" }}>
          {REPORT_DATA.map((d) => (
            <Grid item xs={10} md={3.5}>
              <Stack sx={bStyle} onClick={() => handleClickOpen(Number(d.value))}>
                {" "}
                <img src={d.src} alt="report" style={imgStyle} />
                <p style={pStyle}>{d.text}</p>
              </Stack>
            </Grid>
          ))}
        </Grid> */}
        <MyGrafanaChart />
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={true}
          maxWidth="xl"
        >
          <SubReport selectedReport={selectedReport} />
          {/* <SingleReport /> */}
        </Dialog>
      </Box>
    </>
  );
}
